const cityTaxKeywords = [
  "city tax",
  "toeristenbelasting",
  "tourist",
  "turistskat",
  "gistináttaskattur",
  "tassa di soggiorno",
  "kurtaxe",
  "tasa turística",
  "taxe de séjour",
  "turistskat",
  "borgargjald",
];

export const isCityTaxProduct = (product: {
  ProductName?: { [key: string]: string };
}): boolean => {
  if (!product.ProductName) return false;

  return Object.values(product.ProductName).some((name) => {
    const lower = name.toLowerCase();
    return cityTaxKeywords.some((keyword) => lower.includes(keyword));
  });
};
